import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AddPlatform from "./AddPlatform";

const AddEditPlatform = () => {
  const navigate = useNavigate();
  let location = useLocation();
  let isEdit = false;
  let splitPath = location.pathname.split("/")
  let platformId = "";
  if (splitPath.length > 2) {
    platformId = splitPath[2];
    isEdit = true;
  }

  const callBackSuccess = (data) => {
    navigate("/platforms");
  }

  return (
    <div className="dashboard-card-wrapper">
      <div className="row">
        <AddPlatform callBackSuccess={(data) => callBackSuccess(data)}
          isEdit={isEdit}
          platformId={platformId}
        />
      </div>
    </div>
  )
}
export default AddEditPlatform;